import React from 'react';
import sprintf from 'sprintf';
import SMPaymentSelectHelper from 'components/helpers/SMPaymentSelectHelper';
import SMCardHelper from 'components/helpers/SMCardHelper';
import SMBillingList from 'components/dashboard/shared/SMBillingList';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';

class SMUReservationChangePaymentView extends React.Component {

  constructor(props) {
    super(props);

    this.requestParams = {
      payment_id: props.reservation.billing.post_payment_id,
    };

    this.state = {
      reservation: props.reservation,
      capacities: [],
      cardErrorMessage: "",
      witchCardError: null,
      isDisabled: false,
      activeCards: [],
      paymentSelect: null,
      errors: {},
      isCardOnly: (!this.props.reservation.room.space.enable_bank_payment || this.props.reservation.use_type != SMConst.ReservationUseType.Corporate),
      openNewCard: false,
      selectedCard: props.reservation.billing.post_payment_id,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ 
      reservation: nextProps.reservation,
      selectedCard: nextProps.reservation.billing.post_payment_id
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      $(this.refs.form).startLoading();
      this.requestPayments();
    }
  }

  dismiss(e) {
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.changePaymentViewDidClose === 'function'){
        this.props.delegate.changePaymentViewDidClose();
      }
    }
  }
  
  requestPayments() {
    SMUserResource.getPayments(this.props.currentUser.id, (activeCards, error, xhr)=>{
      if (!error) {
        this.setState({
          activeCards: activeCards,
          openNewCard: false
        });
        $(this.refs.form).stopLoading();
      } else {
        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400: 
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402:
            break;
        }
      }
    });    
  }
  
  requestChangePayment() {
    this.setState({display: SMConst.Display.Loading});
    
    const responseHandler = (reservation, error, xhr)=>{
      if (error) {
        this.setState({
          isDisabled: false,
          display: SMConst.Display.Visible,
        });

        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400: 
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402: 
            this.setState({
              cardErrorMessage: JSON.parse(xhr.responseText).message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
            break;
        }
      } else {
        window.alert("クレジットカードの変更は、承認や払い戻しなど、この後に行われる決済処理のタイミングで反映されます。");
        SMAppHelper.redirectTo(Routes.dashboard_reservation_path(reservation.uid));
      }
    };
    SMUserResource.changePayment(this.props.reservation, this.requestParams, responseHandler);
  }
  
  formDidSubmit(e) {
    e.preventDefault();
    this.setState({
      cardErrorMessage: "",
      witchCardError: null,
      isDisabled: true,
    });
    this.requestChangePayment();
  }
  
  renderCardError() {
    if (this.state.cardErrorMessage && this.state.witchCardError == this.state.paymentSelect) {
      let className = ["reserve-change__required"];
      SMPaymentSelectHelper.isCard(this.state.paymentSelect) ? className.push("ml20") : className.push("mt10");
      return(
        <p className={className.join(' ')}><i className="fa fa-exclamation-circle"></i>{this.state.cardErrorMessage}</p>
      );
    }
    return null;
  }
  
  renderFormItemError(name) {
    const message = this.state.errors[name];
    if (message) { 
      return <p className="is-error mt10"><i className="fa fa-exclamation-circle"></i>{message}</p>;
    }
    return null;
  }
  
  renderCouponError() {
    if (this.state.couponErrorMessage) {
      return <p className="is-error mt10"><i className="fa fa-exclamation-circle"></i>{this.state.couponErrorMessage}</p>;
    }
    return null;
  }
  
  renderActiveCards() {
    const cards = this.state.activeCards;
    const rows = [];
    if (cards) {
      cards.forEach((card, index) => {
        let cardType = card.type.toLowerCase();
        if (cardType == "american express") {
          cardType = "amex";
        }
        const className = sprintf("fa fa-cc-%s fa-lg payment-card__%s", cardType, cardType);

        rows.push(
          <div key={card.id}>
            <input type="radio"
              onClick={this.paymentDidSelect.bind(this)}
              value={SMConst.PaymentSelect.Card}
              checked={this.state.selectedCard == card.id}
              id={"form-radio02__" + card.id}
              name="form-radio02"
              data-paymentId={card.id} />
            <label htmlFor={"form-radio02__" + card.id} className="form-radio mb20">
              <span className="mr10 form-payment-data">
                <i className={className}></i><strong className="settings-data"> **** **** **** {card.last4}</strong></span>
              <span className="mr10 form-payment-data">名義人：<strong className="settings-data">{card.name}</strong></span>
              <span className="mr10 form-payment-data">有効期限：<strong className="settings-data">{card.exp_month}/{card.exp_year}</strong></span></label>
          </div>        
        );
      });      
    }
    
    return(rows);    
  }

  didClickAddNewCard(e) {
    e.preventDefault();
    
    const helper = new SMCardHelper();
    $(this.refs.form).startLoading();
    helper.generateToken({
      success: (response)=>{
        helper.removeCardItemBeforeSubmit();
        SMUserResource.postPayment(this.props.currentUser.username, response.id, (data, error, xhr)=>{
          if(!error) {
            this.setState({ 
              cardErrorMessage: ""
            });
            this.requestPayments();
          } else {
            this.setState({
              cardErrorMessage: response.error.message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
          }
        });
      },
      error: (response)=>{
        $(this.refs.form).stopLoading();
        this.setState({
          cardErrorMessage: response.error.message,
          witchCardError: this.state.paymentSelect,
          isDisabled: false,
        });
      }
    });
  }
  
  toggleNewCard(e) {
    e.preventDefault();
    
    this.setState({
      openNewCard: !this.state.openNewCard
    });
  }
  
  renderNewCard() {
    if (!this.state.openNewCard) return null ;
    
    let card = ["","","","","","","",""];
    if (SpaceMarket.Config.Env == "development") {
      card = ["4242","4242","4242","4242","Dummy","06","2020","111"];
    }
    
    let yearOptions = [];
    const thisYear = (new Date()).getFullYear();
    for (let year = thisYear; year < thisYear + 20; year++) {
      yearOptions.push(
        <option key={year} value={year}>{year}</option>
      );
    }
    
    let monthOptions = [];
    for (let month = 1; month <= 12; month++) {
      monthOptions.push(
        <option key={month} value={sprintf("%02d", month)}>{month}</option>
      );
    }
    let newCardStyle = {};
    if (this.state.activeCards) {
      newCardStyle = {display: "none"};
    }
    
    let errorMessage = null;
    if (this.state.cardErrorMessage) {
      errorMessage = <p className="mb15 is-error"><i className="fa fa-exclamation-circle"></i><span>{this.state.cardErrorMessage}</span></p>;
    }    

    return(
      <div className="ml30">
        <div className="ml120">
          {errorMessage}
          <h3 className="mb5">
            カード番号
            <i className="fa fa-cc-visa fa-lg ml5 payment-card__visa"></i><i className="fa fa-cc-mastercard fa-lg ml5 payment-card__master"></i><i className="fa fa-cc-amex fa-lg ml5 payment-card__amex"></i>
          </h3>
          <div className="mb15">
            <input type="text" name="card[no_1]" defaultValue={card[0]} id="js-card_no_1" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_2]" defaultValue={card[1]} id="js-card_no_2" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_3]" defaultValue={card[2]} id="js-card_no_3" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
            <input type="text" name="card[no_4]" defaultValue={card[3]} id="js-card_no_4" maxLength="4" autoComplete="off" className="js-card-item__remove form-text form-payment-card w60 mr5" />
          </div>
          <h3 className="mb5">
            名義人
            <span className="dashboard-title__supplement ml15">
              クレジットカード表記のまま入力してください。半角英数。
            </span>
          </h3>
          <div className="mb15">
            <input type="text" name="card[name]" defaultValue={card[4]} id="js-card_name" autoComplete="off" placeholder="Taro Space" className="js-card-item__remove form-text w400" />
          </div>
          <h3 className="mb5">
            有効期限
          </h3>
          <div className="mb15">
            <span className="form-select__inner">
              <label className="form-select">
                <select name="card[exp_m]" id="js-card_exp_m" defaultValue={card[5]} className="js-card-item__remove service-select__purpose w70">
                  {monthOptions}
                </select>
              </label>
            </span>
            <span className="form-select__inner">
              <label className="form-select">
                <select name="card[exp_y]" id="js-card_exp_y" defaultValue={card[6]} className="js-card-item__remove service-select__purpose w110">
                  {yearOptions}
                </select>
              </label>
            </span>
          </div>
          <h3 className="mb5">
            セキュリティコード
            <span className="dashboard-title__supplement ml15">
              裏面右端の3桁もしくは表面右端の4桁の数字を入力してください。
            </span>
          </h3>
          <div className="mb15">
            <input className="js-card-item__remove w70" type="text" name="card[cvc]" defaultValue={card[7]} id="js-card_cvc" maxLength="4" autoComplete="off" />
            {SMPaymentSelectHelper.isCard(this.state.paymentSelect) ? this.renderCardError() : null}
          </div>
          <div className="mb20">
            <input onClick={this.didClickAddNewCard.bind(this)} type="button" className="button-blue w100 pt10 pb10" value="追加" />
          </div>
        </div>
      </div>
    );
  }

  paymentDidSelect(e) {
    const value = parseInt(e.currentTarget.value);
    let paymentId = null;
    if (e.currentTarget.getAttribute('data-paymentId')) {
      paymentId = parseInt(e.currentTarget.getAttribute('data-paymentId'));
    }
    this.setPayment(value, paymentId);
  }

  setPayment(value, paymentId) {
    this.setState({
      paymentSelect: value,
      selectedCard: paymentId
    });
    this.requestParams.payment_id = paymentId;
  }

  render() {
    if (!this.props.isOpen) return null;
    const room = this.props.room;
    const buttonClassName = `button-blue request-submit ${(this.state.isDisabled) ? "button-disabled" : ''}`;
    const cancelPolicyUrl = SMAppHelper.policyUrl(room);
    const termsUrl = SMAppHelper.termsUrl(room);
    const canPayCard = room.owner.enable_card;
    const cardSelectStyle = canPayCard ? {} : {display: "none"};
    const newCardStyle = this.state.openNewCard ? "fa fa-chevron-down mr5" : "fa fa-chevron-right mr5";

    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
          <div className="form-casette maincol-lightbox__form reserve-change">
            <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
              <h3 className="dashboard-title mb20">
                <span className="icon-form icon-form__required">必須</span>お支払い方法の変更
              </h3>
              <div style={cardSelectStyle}>
                <div className="mb20">
                  <div className="mb20">
                    <p className="dashboard-title2">クレジットカード</p>
                  </div>
                </div>
                <div className="ml30">
                  {this.renderActiveCards()}
                  <div className="mb20"><a onClick={this.toggleNewCard.bind(this)} href="" className="link-hover-border"><i className={newCardStyle}></i>新しいカードを追加</a></div>
                  {this.renderNewCard()}
                </div>
              </div>
              {this.renderFormItemError('payment_method')}
              <h2 className="dashboard-title mb20 mt50">申込内容の詳細</h2>
              <SMBillingList key={this.state.reservation.id} reservation={this.state.reservation} isOwner={false} />
              <div className="mt30 mb30 ta-c">
                <input className="button-green maincol-buttonarea__button {buttonClassName}" type="submit" value="上記の内容で変更する" disabled={this.state.isDisabled} />
              </div>
            </form>
          </div>
        </div>
        <div className="md-overlay"></div>
      </div>
    );
  }    
}

export default SMUReservationChangePaymentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationChangePaymentView.jsx